import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { HuntPackageRecord } from '@cyborg-monorepo/hunter/common';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../../../../auth/auth.service';
import { HuntPackageService } from '../../services/hunt-package.service';

/**
 * Gates hunt package detail pages for community users trying to access paid content
 */
@Injectable()
export class HuntPackageTrialResolver implements Resolve<HuntPackageRecord> {
  private trialGatePageRoute = '/trial-gate';
  private fourOhFourPageRoute = '/404';

  constructor(
    private router: Router,
    private huntPackageService: HuntPackageService,
    private authService: AuthService
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<HuntPackageRecord> {
    const uuid = route.paramMap.get('hunt_package_uuid');
    return this.huntPackageService.getHuntPackageByUUID(uuid).pipe(
      map((huntPack) => {
        if (this.huntPackageIsAccessible(huntPack)) {
          return huntPack;
        } else {
          void this.router.navigate([this.trialGatePageRoute]);
          return null;
        }
      }),
      catchError(() => {
        void this.router.navigate([this.fourOhFourPageRoute]);
        return EMPTY;
      })
    );
  }

  private huntPackageIsAccessible(huntPackage: HuntPackageRecord): boolean {
    const user = this.authService.user$.value;
    const inTrial = user?.company.status === 'trial';

    return !inTrial || huntPackage.community;
  }
}
